import { useMemo } from 'react';
import { getContentArea } from 'cart-core';

const useContentArea = (
    areaName: string
) => useMemo(() => getContentArea(areaName), [areaName]);

export default useContentArea;
